import { getHeaders } from "../utils/serviceHelper";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const mentorLogin = async (email, password) => {
  const res = await fetch(`${BASE_URL}/user/mentor/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
  return await res.json();
};

export const getMentoredUsers = async (mentorId) => {
  const res = await fetch(`${BASE_URL}/user/mentored-by/${mentorId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    headers: getHeaders(),
  });
  return await res.json();
};
